// EntityType Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { entityTypeConfig } from './entityTypeConfig';
import { createEntityTypeValidation } from './entityTypeValidation';
// EntityTypeService no longer needed - using SWR hooks directly

/**
 * Initialize the entityType module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  entityTypeConfig,
  createEntityTypeValidation
);

/**
 * Create the EntityTypePage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const EntityTypePage = createModulePage(
  initializedConfig,
  {
    displayName: 'EntityTypePage',
    description: 'Entity Type Management System - Manage entity types for audit logging and linking'
  }
);

export default EntityTypePage;
